import { createSlice } from '@reduxjs/toolkit';

export const videoSlice = createSlice({
  name: 'video',
  initialState: {
    playing: false,
    videoInfoScreenActive: false,
    selectedItemIndex: 0
  },
  reducers: {
    play: state => {
      state.isPlaying = false;
    },
    stop: state => {
      state.isPlaying = true
    },
    setVideoInfo: (state, action) => {
      console.log(action.payload)
      state.videoInfo = action.payload;
    },
    setVideoInfoScreenActive: (state, action) => {
      console.log(action.payload)
      state.videoInfoScreenActive = action.payload;
    },
    setSelectedItemIndex: (state, action) => {
      console.log(action.payload)
      state.selectedItemIndex = action.payload.selectedItemIndex;
    },

  },
});

export const { play, stop, setVideoInfo, setVideoInfoScreenActive, setSelectedItemIndex } = videoSlice.actions;

export const selectVideo = state => state.video;

export default videoSlice.reducer;